export enum ActionTypes {
    LOGOUT = "LOGOUT",
    RESET_SITE_ROLE = "RESET_SITE_ROLE"
}
